export RangeSlider from './RangeSlider';



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/RangeSlider/index.js